<script lang="ts">
	import { urlFragment } from '../../stores/url-fragment';
	import { levels, levelGroups } from '../../levels';
	import { startLevel } from '../../stores/current-level';
	import Icon from '../elements/Icon.svelte';
</script>

<h1>
	Level Select
</h1>

<hr />

<div class="level-list">
	{#each levelGroups as group }
		<h2>{ group.title }</h2>

		<ul>
			{#each group.levels as levelName }
				<li on:click={ () => startLevel( levelName ) }>
					{ levels[ levelName ].title }
				</li>
			{/each}
		</ul>
	{/each}
</div>
	
<hr />

<button class="large" on:click={ () => urlFragment.setUrlKey( 'menu', 'levelInfo' ) }>
	<Icon i="arrow-left" />
	Back
</button>

<style>
	.level-list {
		max-height: 300px;
		min-width: 450px;
		overflow-y: auto;
	}

	.level-list ul {
		list-style: none;
	}

	.level-list li {
		cursor: pointer;
	}
</style>
